//
// Generated class EmployeePool
//

/// <reference path="EmployeePool_ManagedObject.ts" />

class EmployeePool extends EmployeePool_ManagedObject
{

}
